import {BaseModule} from "./base/base";

export class BackButton extends BaseModule {
    constructor(selector = '.btn__back') {
        super();
        const button = document.querySelector(selector) as HTMLElement;

        if (button) {
            if (window.history.length > 1) {
                button.addEventListener('click', () => {
                    window.history.back();
                });
            } else {
                button.style.display = 'none';
            }
        }
    }

}
